export default __webpack_public_path__ + "static/media/XEMP-19.8e44f02f.jpg";